const UsuarioList = () => import("~/components/Views/Prova/Usuario/List");
const UsuarioNew = () => import("~/components/Views/Prova/Usuario/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Configurações", link: "" }
];

export const usuario = [
  {
    path: "configuracoes/usuario",
    component: UsuarioList,
    name: "Usuário",
    meta: {
      title: "Usuário",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/usuario/new",
    component: UsuarioNew,
    name: "Novo Usuário",
    meta: {
      title: "Novo Usuário",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/usuario/:id",
    component: UsuarioNew,
    name: "Alterar Usuário",
    meta: {
      title: "Alterar Usuário",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/configuracao/usuario.js